// import services from './../../../services/service'; // Service Class
import SecondHeader from './../../Second-Header/index.vue'; // Second Header
import Sidebar from './../../Sidebar/index.vue'; // Sidebar
import MainFooter from './../../Main-Footer/index.vue'; // Main Footer
import SearchBar from '../../SearchBar.vue'; // Search Bar

import services from './../../../services/service'; // Service Class
import validator from './../../../services/validator'; // Service
import DashboardHeader from './../../Dashboard-Header/index.vue'; // Dashboard Header
import DashboardSidebar from './../../Dashboard-Sidebar/index.vue'; // Dashboard Sidebar
import DashboardFooter from './../../Dashboard-Footer/index.vue'; // Dashboard Footer

import Preset from './../../../mixins/preset.js'; //preset
import CNinsuranceForm from '../../../templates/CNInsuranceForm/index.vue'
import CNinsuranceFileCompliant from '../../../templates/CNinsuranceFileComplaint/index.vue'
import CNinsuranceFileClaim from '../../../templates/CNinsuranceFileClaim/index.vue'

let service = new services();
let valid = new validator();
export default {
    name: 'CNinsuranceAccounts',
    mixins: [Preset],
    data () {
        return {
            user:{},
            cninsurance_accounts:{},
            cninsurance_account:{},
            cninsurance_account_forms:{},
            cninsurance_partner:{},
            cninsurance_form:{},
            cninsurance_data:{}, //for propping
            current_form_data:{},
            current_form_data_form_entries:{},
            cninsurance_account_claims:{},
            cninsurance_account_complaints:{},
            cninsurance_claim:{},
            cninsurance_complaint:{},
            cninsurance_account_unsubmitted_forms:0,
            cninsurance_account_unpaid_forms:0,
            viewAll:false, //for now
            viewOne:true,
            set_component_view:{},
            set_main_view:{},
            //for renew selected form
            set_renew_selected: false,
            set_renew_selected_form_data:{},
            set_renew_selected_form_data_form_entries:{},
            //for resubmits
            set_resubmit: false,
            set_submit_form_data:{},
            set_submit_form_data_form_entries:{},
            loading:true,
        }
    },
    components: {
        'component-header': DashboardHeader,
        'component-sidebar': DashboardSidebar,
        'component-footer': DashboardFooter,
        'cninsurance-post-form': CNinsuranceForm,
        'cninsurance-file-complaint': CNinsuranceFileCompliant,
        'cninsurance-file-claim': CNinsuranceFileClaim
    },
    methods: {
        //settings
        closeModal(modal){
            $(modal).modal("hide");
            $('.modal-backdrop').remove();
            this.reset_views();
        },

        reset_views(){
            this.set_component_view = {};
        },

        setMainView(view,attr1,attr2){
            this.set_main_view = {};
            this.set_main_view[view] = true;
            //some stts
            //--renew selected form
            if(view == "renew_selected"){
                this.set_renew_selected = true; //for telling set_cninsurance_form_values func i am for renew
                this.set_renew_selected_form_data = attr1; //store here
                this.set_cninsurance_form_values(attr1.cninsurance_form_entries);
            }
            //--resubmit
            if(view == "resubmit"){
                this.set_resubmit = true; //for telling set_cninsurance_form_values func i am for submit
                this.set_submit_form_data = attr1; //store here
                this.set_cninsurance_form_values(attr1.cninsurance_form_entries);
            }
        },

        setComponentView(view,attr1,attr2){
            this.set_component_view = {};
            this.set_component_view[view] = true;
        },

        setPanel(attr,attr2) {
            this.panelFlag = true;

            if(attr == "add"){
                this.editFlag = false;
                this.deleteFlag = false;
                this.addFlag = true;
            }

            if(attr == "edit"){
                this.addFlag = false;
                this.deleteFlag = false;
                this.editFlag = true;
                this.business = attr2;
            }

            if(attr == "delete"){
                this.addFlag = false;
                this.editFlag = false;
                this.deleteFlag = true;
                this.business = attr2;
            }

            if(attr == "view-cnsurveys"){
                this.addFlag = false;
                this.editFlag = false;
                this.deleteFlag = false;
                this.cnsurveysPanel = true;
                //this.getBusinessWorkingHours(attr2);
               
            }

        },
        
        isActive(index){
            if(index == 1){
                return "active";
            }
        },

        getStates() {
            service.getStates(this).then(function(data) {
                this.states = data.body;
            })
        },

        // getCities(state) {
        //     service.getCities(this, state).then(data => {
        //         this.cities = data.body.data;
        //     })
        // },
 
        // Get cities
        getCities(id) {
            document.getElementById("loader").style.visibility = "visible";
            service.getCities(this, id).then((res) => {
                this.cities = res.body.data;
                document.getElementById("loader").style.visibility = "hidden";
            })
        },
       
       
        //--//settings

        //businesses
        getBusinessCategories() {
            service.getBusinessCategories(this).then(data => {
                if(data.body.status == 200) {
                    this.businessCategories = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                   // toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

         //
         setModalContentView(view,attr1,attr2){
            //close all modals
            $('.modal').modal('hide');
            /*
                //Also if you would like to do something if the modal is hidden then you can do this:

                $('.modal').on('hidden', function () {
                // write your code
                });
            */
            if(view == 'show_form'){
                this.cninsurance_form = attr1;
                this.cninsurance_data.cninsurance_form = this.cninsurance_form.cninsurance_form_policy_id;
                $('#show_form').modal();
            }
            else if(view == 'show_claim'){
                this.cninsurance_claim = attr1;
                $('#show_claim').modal();
            }
            
        },
      
        //
        set_cninsurance_form_values(form){ 
            let set_form = {};
            for(let entry of form){
                //first name
                if(entry.cninsurance_form_entry_type == 1){
                    set_form.cninsurance_form_first_name = entry.cninsurance_form_entry_value;
                }
                //last name
                if(entry.cninsurance_form_entry_type == 2){
                    set_form.cninsurance_form_last_name = entry.cninsurance_form_entry_value;
                }
                //dob
                if(entry.cninsurance_form_entry_type == 3){
                    set_form.cninsurance_form_dob = entry.cninsurance_form_entry_value;
                }
                //gender
                if(entry.cninsurance_form_entry_type == 4){
                    set_form.cninsurance_form_gender = entry.cninsurance_form_entry_value;
                }
                //email
                if(entry.cninsurance_form_entry_type == 5){
                    set_form.cninsurance_form_email = entry.cninsurance_form_entry_value;
                }
                //phone
                if(entry.cninsurance_form_entry_type == 6){
                    //--set some setts for tricky auto removed leading zeros from phone num
                    let set_no = entry.cninsurance_form_entry_value_f.split("_");
                    set_form.cninsurance_form_phone = set_no[1]; //entry.cninsurance_form_entry_value;
                }
                //address
                if(entry.cninsurance_form_entry_type == 7){
                    set_form.cninsurance_form_address = entry.cninsurance_form_entry_value;
                }
                //vehicle_reg_no
                if(entry.cninsurance_form_entry_type == 8){
                    set_form.cninsurance_form_vehicle_reg_no = entry.cninsurance_form_entry_value;
                }
                //vechicle class
                if(entry.cninsurance_form_entry_type == 9){
                    // set_form.cninsurance_form_vehicle_class = entry.cninsurance_form_entry_value;
                    for(let va of this.cninsurance_partner.cninsurance_form_variables){
                        //vehicle classs
                        if(va.cninsurance_form_variable_type_id == 9){
                            for(let vc of va.cninsurance_form_variable_type_values){
                                //selected vehicle classs
                                if(vc.cninsurance_form_variable_id == entry.cninsurance_form_entry_value_has_id){
                                    set_form.cninsurance_form_vehicle_class = vc;
                                }
                            }
                        }
                    }
                }
                //vechicle make
                if(entry.cninsurance_form_entry_type == 10){
                    set_form.cninsurance_form_vehicle_make = entry.cninsurance_form_entry_value;
                }
                //vechicle model
                if(entry.cninsurance_form_entry_type == 11){
                    set_form.cninsurance_form_vehicle_model = entry.cninsurance_form_entry_value;
                }
                //cninsurance_form_vehicle_number_plate
                if(entry.cninsurance_form_entry_type == 12){
                    set_form.cninsurance_form_vehicle_number_plate = entry.cninsurance_form_entry_value;
                }
                //cninsurance_form_vehicle_chassis_number
                if(entry.cninsurance_form_entry_type == 13){
                    set_form.cninsurance_form_vehicle_chassis_number = entry.cninsurance_form_entry_value;
                }
                //cninsurance_form_vehicle_engine_number
                if(entry.cninsurance_form_entry_type == 14){
                    set_form.cninsurance_form_vehicle_engine_number = entry.cninsurance_form_entry_value;
                }
                //cninsurance_form_year_of_manufacture
                if(entry.cninsurance_form_entry_type == 15){
                    set_form.cninsurance_form_year_of_manufacture = entry.cninsurance_form_entry_value;
                }
                //cninsurance_form_year_of_purchase
                if(entry.cninsurance_form_entry_type == 16){
                    set_form.cninsurance_form_year_of_purchase = entry.cninsurance_form_entry_value;
                }
                //cninsurance_form_policyholder_type
                // if(entry.cninsurance_form_entry_type == 17){
                //     set_form.cninsurance_form_policyholder_type = entry.cninsurance_form_entry_value;
                // }
                if(entry.cninsurance_form_entry_type == 17){
                    for(let va of this.cninsurance_partner.cninsurance_form_variables){
                        //policyholder_type
                        if(va.cninsurance_form_variable_type_id == 17){
                            for(let ph of va.cninsurance_form_variable_type_values){
                                //selected policyholder_type
                                if(ph.cninsurance_form_variable_id == entry.cninsurance_form_entry_value_has_id){
                                    set_form.cninsurance_form_policyholder_type = ph;
                                }
                            }
                        }
                    }
                }
                //cninsurance_form_company_name
                if(entry.cninsurance_form_entry_type == 18){
                    set_form.cninsurance_form_company_name = entry.cninsurance_form_entry_value;
                }
            }
            if(this.set_renew_selected){
                //more a selected form renew
                this.set_renew_selected_form_data_form_entries = set_form;
                this.set_renew_selected = false; //free here
            }else if(this.set_resubmit){
                //more specific setting ref form
                set_form.cninsurance_form_ref = this.set_submit_form_data.cninsurance_form_ref;
                this.set_submit_form_data_form_entries = set_form;
                this.set_resubmit = false; //free here
            }else{
                //default renew
                this.current_form_data_form_entries = set_form;
            }
        },

       
       
        getCNinsuranceAccounts(){
            service.getCNinsuranceUserAccounts(this,this.user.user_id).then(data => {
                if(data.body.status == 200) {
                    this.cninsurance_accounts = data.body.data;
                    this.cninsurance_account = this.cninsurance_accounts[(this.cninsurance_accounts.length)-1];
                    //get the cninsurance
                    this.cninsurance_partner = this.cninsurance_account.cninsurance_account_cninsurance_data;
                    //get the account forms
                    this.getCNinsuranceUserAccountForms();
                }
            }).catch((err) => {
                if(err) {
                    this.loading = false;
                // toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },


        //forms
        getCNinsuranceUserAccountForms(){
            if(this.cninsurance_account.cninsurance_account_id > 0){
                service.getCNinsuranceAccountForms(this,this.cninsurance_account.cninsurance_account_id).then(data => {
                    if(data.body.status == 200) {
                        this.cninsurance_account_forms = data.body.data;
                        // this.current_form_data = this.cninsurance_account_forms[(this.cninsurance_account_forms.length)-1];
                        //fetch from server instead
                        this.current_form_data = data.body.data_current_form_data;
                        this.set_cninsurance_form_values(this.current_form_data.cninsurance_form_entries);
                        this.cninsurance_account_unpaid_forms = data.body.data_count_unpaid;
                        this.cninsurance_account_unsubmitted_forms = data.body.data_count_unsubmit;
                        //set form detail
                        let form_index = 0;
                        for(let form of this.cninsurance_account_forms){
                            this.cninsurance_account_forms[form_index].form_details = '';
                            let form_vechicle_make = ''; let form_vechicle_model = '';
                            for(let entry of form.cninsurance_form_entries){
                                //make
                                if(entry.cninsurance_form_entry_type == 10){
                                    form_vechicle_make = entry.cninsurance_form_entry_value;
                                }
                                //model
                                if(entry.cninsurance_form_entry_type == 11){
                                    form_vechicle_model = entry.cninsurance_form_entry_value;
                                }
                            }
                            this.cninsurance_account_forms[form_index].form_details = form_vechicle_make+" "+form_vechicle_model;
                            form_index++;
                        }
                        //
                        this.getCNinsuranceUserAccountClaims();
                        this.getCNinsuranceUserAccountComplaints();
                        //
                        this.loading = false;
                    }
                }).catch((err) => {
                    if(err) {
                        this.loading = false;
                    // toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }
        },


        //claims
        getCNinsuranceUserAccountClaims(){
            service.getCNinsuranceAccountClaims(this,this.cninsurance_account.cninsurance_account_id).then(data => {
                if(data.body.status == 200) {
                    this.cninsurance_account_claims = data.body.data;
                }
            }).catch((err) => {})
        },

        //complaints
        getCNinsuranceUserAccountComplaints(){
            service.getCNinsuranceAccountComplaints(this,this.cninsurance_account.cninsurance_account_id).then(data => {
                if(data.body.status == 200) {
                    this.cninsurance_account_complaints = data.body.data;
                }
            }).catch((err) => {})
        },
        

    },
    mounted: function(){
        // this.getCNinsuranceAccounts();
        let self = this;
        // setTimeout(function (){
        //     self.getCNinsuranceAccounts();
        // }, 1500);
    },
    created: function(){
        this.setMainView('forms');
      // this.preset();
    //    this.getCNinsuranceAccounts();
    }
}


// WEBPACK FOOTER //
// ./src/components/Account/CNinsurance/script.js